import React, { Component } from 'react';
import { BrowserRouter as Router, Switch , Route } from 'react-router-dom';
import appRoutes from "./routes";

const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
const token = match ? match[2] : null;
if(!token ) {
    if(window.location.pathname === '/' ) {
        //
    }

    else  {
        window.location.replace('/')
    }
}
class App extends Component {
    render() {
        return (
            <Router>
                <Switch>
                    {
                        appRoutes.map (route=>(
                            <Route key={route.id} exact path={route.path} component={route.component} />
                        ))
                    }
                </Switch>
            </Router>
        );
    }

    componentDidMount = () => {
        const domain = window.location.hostname;
        if(domain === 'www.barsepar.com' || domain === 'barsepar.com') {
            window.localStorage.setItem("sysTitle", ' بارسپار ');
        }
        else {
            window.localStorage.setItem("sysTitle", ' گوهر زمین طوس ');
        }
    }
}



export default App;